<script setup lang="ts">
import { watch, ref } from "vue";
import { EducationCategoryCard } from "#components";
import qs from "qs";

export interface CategorySectionProps {
  categoryId: number;
  slug: string;
  section: {
    id: number;
    title: string;
    link_text: string;
  };
}

const props = defineProps<CategorySectionProps>();

const query = qs.stringify(
  {
    fields: ["title", "slug"],
    populate: {
      education_category: {
        fields: ["name"],
      },
      image: {
        fields: ["url", "name"],
      },
    },
    filters: {
      education_category: {
        $eq: props.categoryId,
      },
    },
    pagination: {
      limit: 6,
    },
    sort: "createdAt:desc",
  },
  {
    encodeValuesOnly: true,
  },
);

const { data: categoryData } = useCustomFetch(
  `/api/strapi-full/education-posts?${query}`,
);

const data = computed(() => categoryData.value?.data);
</script>

<template>
  <div
    :id="section.title.toLowerCase()"
    :key="section.id"
    v-if="data?.length > 0"
    class="category-section mt-40"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title m-0">
        {{ section.title }}
      </h2>
      <NuxtLinkLocale
        :to="`/education-category/${props.slug}`"
        class="btn btn-link btn-lg"
        ><strong>{{ section.link_text }}</strong></NuxtLinkLocale
      >
    </div>
    <div class="row">
      <div
        v-if="data"
        v-for="post in data"
        class="col-xs-12 col-md-6 col-lg-4 mt-20"
      >
        <EducationCategoryCard
          :key="post.id"
          :slug="post.attributes.slug"
          :title="post.attributes?.title"
          :image="post.attributes?.image"
        />
      </div>
    </div>
  </div>
</template>
